// src/services/footer.js
import api from './api';

const FOOTER_ENDPOINTS = {
  GET_FOOTER: '/footer',
  UPDATE_FOOTER: '/footer'
};

export const getFooter = async () => {
  try {
    const response = await api.get(FOOTER_ENDPOINTS.GET_FOOTER);
    return response;
  } catch (error) {
    throw error;
  }
};

export const updateFooter = async (footerData) => {
  try {
    const response = await api.put(FOOTER_ENDPOINTS.UPDATE_FOOTER, footerData);
    return response;
  } catch (error) {
    throw error;
  }
};

export default {
  getFooter,
  updateFooter
};